function convertCmToInch(cm) {
  return (cm * 0.393701).toFixed(0); // Convert to inches and round to 2 decimal places
}

function convertSpecialCases(input) {

  // Case: "<70"
  if (input.startsWith('<')) {
    const value = parseFloat(input.substring(1));
    return `<${convertCmToInch(value)}`;
  } else if (input.startsWith('>')) {
    const value = parseFloat(input.substring(1));
    return `>${convertCmToInch(value)}`;
  } else if (input.includes('-')) {
    const [min, max] = input.split('-').map(Number);
    return `${convertCmToInch(min)}-${convertCmToInch(max)}`;
  } else if (input.includes('/')) {
    const [numerator, denominator] = input.split('/').map(Number);
    const value = numerator / denominator;
    return `${convertCmToInch(numerator)}/${convertCmToInch(denominator)}`;
  } else {
    return convertCmToInch(Number(input));
  }

  return 'Invalid input';
}

class SizeGuide extends HTMLElement {
  constructor() {
    super()
    this.measure = "cm"
  }

  connectedCallback() {
    this.init()
  }

  disconnectedCallback() {
    this.showModal(false)
  }

  showModal(flag) {
    
    if (flag) {
      this.querySelector(".m_block").classList.remove("hidden")
      setTimeout(() => {
        this.classList.add("reveal")
      },50)
      document.documentElement.classList.add("no-scroll")
    } else {
     this.classList.remove("reveal")
      setTimeout(() => {
        this.querySelector(".m_block").classList.add("hidden")
      },500)
      document.documentElement.classList.remove("no-scroll")
    }
  }
  
  handleTabClick(event) {
    const tab = event.target.dataset.tab
    const tab_controls = this.querySelectorAll(".m_tabs_control__tab")
    const tabs = this.querySelectorAll(".m_tab")

    tab_controls.forEach(tab => {
      tab.classList.remove("m_tabs_control__tab--active")
    })

    tabs.forEach(tab => {
      tab.classList.add("hidden")
      setTimeout(() => {
        tab.classList.remove("active_tab")
      }, 30)
    })

    const tabContent = this.querySelector(`#${tab}`)
    tabContent.classList.remove("hidden")
    
    setTimeout(() => {
      tabContent.classList.add("active_tab")
    }, 30)

    event.target.classList.add("m_tabs_control__tab--active")
  }

  addEventListeners() {
    const tabs = this.querySelectorAll(".m_tabs_control__tab")
    tabs.forEach(tab => {
      tab.addEventListener("click", this.handleTabClick.bind(this))
    })
  }

  initAccordions() {
    const accordions = this.querySelectorAll(".m_accordion")
    accordions.forEach(accordion => {
      const accordionTop = accordion.querySelector(".m_accordion-top")
      const accordionBottom = accordion.querySelector(".m_accordion-bottom")
      if (!accordionTop) return
      if (!accordionBottom) return
      accordionTop.addEventListener("click", () => {
        accordions.forEach(acc => {
          acc.classList.remove("m_accordion--active")
        })
        accordionTop.closest(".m_accordion").classList.add("m_accordion--active")
      })
    })
  }

  initMeasureSwitcher() {
    const measures = this.querySelectorAll(".m_switcher")
    measures.forEach(measure => {
      const measureDot = measure.querySelector("[data-m-switcher]")
      measureDot.addEventListener("click", () => {
        measureDot.classList.toggle("active")
        this.convertAllMeasuresToInch(this.measure)
        this.measure = this.measure === "cm" ? "inch" : "cm"
      })
    })
  }


  convertAllMeasuresToInch(m) {
    const measures = this.querySelectorAll("[data-cm]")
    
    measures.forEach(measure => {
      const cm = measure.dataset.cm
      const inch = convertSpecialCases(measure.dataset.cm)
      
      measure.innerHTML = m === 'cm' ? inch : cm
    })
  }

  initOverlay() {
    document.addEventListener('click', e => {
      if (e.target.classList.contains("m_overlay")) {
        this.showModal(false)
      }
    })
  }

  initPdpOpener() {
    const pdpOpener = document.querySelector(`.m_btn_opener`)
    
    if (!pdpOpener) return
    pdpOpener.addEventListener("click", e => {
    console.log(pdpOpener)

      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      this.showModal(true)
    })
  }

  init() {
    this.addEventListeners()
    this.initAccordions()
    this.initMeasureSwitcher()
    this.initOverlay()
    this.initPdpOpener()
    const close = document.querySelector('.m_close')
    if (close) { 
    close.addEventListener('click', function() {
      document.querySelector('size-guide').classList.remove("reveal")
      setTimeout(() => {
        document.querySelector(".m_block").classList.add("hidden")
        document.querySelectorAll('video').forEach(element => {
          element.pause()
        });
        const howToVideo = document.querySelector('#m_size-how-to-measure iframe')
        const howToVideoSrc = howToVideo.getAttribute('src')
        howToVideo.setAttribute('src', '')
        howToVideo.setAttribute('src', howToVideoSrc)
      },500)
      document.documentElement.classList.remove("no-scroll")
    })
  }
  }
}

customElements.define("size-guide", SizeGuide)